<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.isMobile()) {
      this.$router.replace({ name: "wap" });
    } else {
      // this.$router.replace({ name: 'column' })
      var app = document.querySelector("#app");
      // app.style.maxWidth = "1920px";
      // app.style.minWidth = "960px";
      app.style.margin = "0 auto";
      app.style.position = "relative";
    }
  },
};
</script>

<style lang="scss">
body {
  margin: 0 auto;
  background: #f4f3f2;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-dialog {
  border-radius: 10px !important;
}
</style>
